var map = {
	"./Avimar Villas.webp": 455,
	"./Evidence Map.webp": 778,
	"./Geolocating News.webp": 935,
	"./Homeless Service Map.webp": 57,
	"./Impact Estimator.webp": 678,
	"./viva.com.webp": 702
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21;